import { useTranslation } from 'react-i18next';
import { useDialogs } from '@cbridge-modules/dialog';

export const useConfirmNavigateAway = () => {
  const { t } = useTranslation();
  const dialogs = useDialogs();

  const confirmNavigateAway = () => dialogs.confirm(
    t('text:common.dialog.unsavedChanges.description'),
    {
      title: t('text:common.dialog.unsavedChanges.title'),
      okText: t('text:common.dialog.unsavedChanges.leave'),
      cancelText: t('text:common.dialog.unsavedChanges.stay'),
    },
  );

  return { confirmNavigateAway };
};
